// extracted by mini-css-extract-plugin
module.exports = {"cont-answers":"cont-answers","contAnswers":"cont-answers","container":"container"};